module.exports = __webpack_public_path__ + "img/promobox_02.481dc6ee.svg";